import { useState } from "react";

import { AmountAdjuster } from "@components/AmountAdjuster";
import { trumpContributionFrequencyOptions } from "@components/Goals/TrumpSidecar";
import { Overlay } from "@components/Overlay";
import { OverlayProps } from "@components/Overlay/types";
import { SegmentedControl } from "@components/SegmentedControl";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { H2 } from "@components/Typography";
import { DEFAULT_DEPOSIT_ADJUSTMENT, MAX_DEPOSIT_AMOUNT } from "@constants";
import { TrumpContributionFrequency } from "@ctypes";
import { useModal } from "@hooks";
import { Translations, i18n } from "@i18n";
import { getMinDepositAmount } from "@utils";
import { AdjustContributionModalProps } from "./types";

export const AdjustContributionModal = ({
  currentAmount,
  currentFrequency,
  onUpdate,
}: AdjustContributionModalProps) => {
  const { dismiss } = useModal();

  const [amount, setAmount] = useState(currentAmount);
  const [frequency, setFrequency] = useState(currentFrequency);

  const props: OverlayProps = {
    cta: {
      primary: {
        title: i18n.t(Translations.EditGoalRouteUpdateCTA),
        onClick: () => {
          onUpdate(amount, frequency);
          dismiss();
        },
      },
    },
  };

  return (
    <Overlay {...props}>
      <H2>{i18n.t(Translations.EditGoalRouteAdjustContributionTitle)}</H2>
      <Spacing size={SpacingSizes.M} />

      <AmountAdjuster
        amount={amount}
        onAmountChange={setAmount}
        min={getMinDepositAmount()}
        max={MAX_DEPOSIT_AMOUNT}
        step={DEFAULT_DEPOSIT_ADJUSTMENT}
      />
      <Spacing size={SpacingSizes.M} />

      <SegmentedControl
        options={trumpContributionFrequencyOptions}
        selectedKey={frequency}
        onSelect={(key) => setFrequency(key as TrumpContributionFrequency)}
      />
      <Spacing size={SpacingSizes.M} />
    </Overlay>
  );
};
